﻿/**
 * commercial_data
 */
// COMMERCIAL: Include necessary property data for listings in separate files.

define([], function() {
    'use strict';
    var data = [
        {
            id: 605,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_605_TEXT
        },
        {
            id: 602,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_602_TEXT
        },
        {
            id: 601,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_601_TEXT
        },
        {
            id: 603,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_603_TEXT
        },
        {
            id: 604,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_604_TEXT
        },
        {
            id: 678,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_678_TEXT
        },
        {
            id: 'optgroup',
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_600_TEXT
        },
        {
            id: 682,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_682_TEXT
        },
        {
            id: 681,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_681_TEXT
        },
        {
            id: 679,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_679_TEXT
        },
        {
            id: 600,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_600_TEXT
        },
        {
            id: 680,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_680_TEXT
        },
        {
            id: 'optgroupend',
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_600_TEXT
        },
        {
            id: 683,
            name: window.RESAAS.Localization.Global.COMMERCIAL_PROPERTY_TYPE_683_TEXT
        },
        {
            id: 113,
            name: window.RESAAS.Localization.Global.PROPERTY_TYPE_113_TEXT
        }
    ];
    var module = {
        browse: function() {
            return data;
        }
    };

    return module;
});
